<template>
	<div class="detail-table">
		<Commontable :tableData="tableData" :headerData="headerData" :loadingTable="false"></Commontable>
	</div>
</template>

<script>
	import Commontable from "@/components/common-table.vue";

	export default {
		components: {
			Commontable
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				headerData: [{
						prop: 'HospitalName',
						label: '医院名称',
						columnwidth: 180
					},
					{
						prop: 'ProvinceName',
						label: '省份',
						columnwidth: 100
					},
					{
						prop: 'HosGradeName',
						label: '医院等级',
						columnwidth: 120
					},
					{
						prop: 'TechnicalOffices',
						label: '科室',
						columnwidth: 120
					},
					{
						prop: 'Doctor',
						label: '术者',
						columnwidth: 100
					},
					{
						prop: 'DoctorTitle',
						label: '术者职称',
						columnwidth: 100
					},
					{
						prop: 'SurgeryCountPerYear',
						label: '手术量',
						columnwidth: 100
					},
					{
						prop: 'InHospitalStatusName',
						label: '入院状态',
						columnwidth: 100
					},
					{
						prop: 'LEVEL3',
						label: '重点产品',
						columnwidth: 150
					},
					{
						prop: 'SalesAmountPerMonth',
						label: '月均销量',
						columnwidth: 100
					}
				]
			};
		}
	};
</script>

<style scoped>
	.detail-table {
		width: 100%;
	}
</style>